import { render, staticRenderFns } from "./UserInviteListDataTable.vue?vue&type=template&id=710f954b&"
import script from "./UserInviteListDataTable.vue?vue&type=script&lang=js&"
export * from "./UserInviteListDataTable.vue?vue&type=script&lang=js&"
import style0 from "./UserInviteListDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports